import 'es6-promise/auto';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from './store';

import Login from './components/Login.vue';
import Register from './components/Register.vue';
import Flight from './components/Flight.vue';
import ResetPassword from './components/ResetPassword.vue'

const routes = [
  {path: '/', component: Login, name: 'login'},
  {path: '/cadastro', component: Register, name: 'register'},
  {path: '/voo', component: Flight, name: 'flight'},
  {path: '/resetar-senha', component: ResetPassword, name: 'reset'},
  {path: '*', component: Register, name: 404}
];

const router = new VueRouter({
  routes: routes
});

router.beforeEach((to, from, next) => {
  if ((to.name !== 'login' && to.name !== 'reset') && (Store.state.token == null || Store.state.token == "null")) {
    next({name: 'login'});
  } else {
    next();
  }
});

export default router


// WEBPACK FOOTER //
// ./src/routes.js